import routerOptions0 from "/home/les/work/depalop/etmflex/frontend/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: true,
  scrollBehaviorType: "auto"
}
export const hashMode = true
export default {
...configRouterOptions,
...routerOptions0,
}